module.exports = __webpack_public_path__ + "static/media/natalia-barbosa.44e1cc0c.jpg";